import { DOCUMENT } from '@angular/common';
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Inject,
    Input,
    OnChanges,
    OnDestroy,
    PLATFORM_ID,
    QueryList,
    ViewChildren,
} from '@angular/core';
import { Router } from '@angular/router';
import { ActivePanelInterface } from '@app/core/interfaces';
import { Dossier } from '@app/core/interfaces/dossier';
import { ScrollService } from '@app/core/scroll/scroll.service';
import { WINDOW } from '@inshared/shared/util';
import { AppRoutesEnum } from '@app/routes';
import { PanelService } from '@app/shared/services/panel.service';
import { PanelExpandableComponent } from '@app/shared/ux/panel-expandable/panel-expandable.component';
import { Subscription } from 'rxjs';

@Component({
    selector: 'ins-claims-overview',
    templateUrl: './claims-overview.component.html',
    styleUrls: ['./claims-overview.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClaimsOverviewComponent implements OnChanges, OnDestroy {
    @ViewChildren(PanelExpandableComponent) children: QueryList<PanelExpandableComponent>;
    @Input() loaded: boolean;
    @Input() files: Dossier[];
    @Input() open: Dossier[];
    @Input() unfinished: Dossier[];
    @Input() allClaims: Dossier[];
    @Input() activePanel: ActivePanelInterface;

    public baseUrl: string;
    public openClaims: boolean = false;
    public closedClaims: boolean = false;

    private subscriptions = new Subscription();

    constructor(
        private scrollService: ScrollService,
        private changeDetectorRef: ChangeDetectorRef,
        private panelService: PanelService,
        private router: Router,
        private cdRef: ChangeDetectorRef,
        @Inject(PLATFORM_ID) private platformId: object,
        @Inject(DOCUMENT) private document: Document,
        @Inject(WINDOW) private window: Window
    ) {
        this.baseUrl = this.document.location.origin;
    }

    ngOnChanges(): void {
        this.updateView();
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    public onReportClaim(): void {
        this.window.location.href = AppRoutesEnum.OldClaimFunnel;
    }

    public showHideOpenClaims(): void {
        this.openClaims = !this.openClaims;
        const queryParams = {
            panel: 'lopende-dossiers',
            scrollTo: 'lopende-dossiers',
        };

        this.router.navigate([], {
            queryParams,
            queryParamsHandling: 'merge',
        });

        this.panelService.handleQueryParams(queryParams as ActivePanelInterface, this.children, this.cdRef);
        this.updateView();
    }

    public showHideClosedClaims(): void {
        this.closedClaims = !this.closedClaims;

        const queryParams = {
            panel: 'gesloten-dossiers',
            scrollTo: `gesloten-dossiers`,
        };

        if (this.closedClaims === false) {
            this.router.navigate([], {
                queryParams,
                queryParamsHandling: 'merge',
            });
        }
        this.panelService.handleQueryParams(queryParams as ActivePanelInterface, this.children, this.cdRef);
        this.updateView();
    }

    private updateView(): void {
        if (this.activePanel !== null && this.activePanel.scrollTo) {
            this.scrollService.scrollElementOffset(`#${this.activePanel.scrollTo}`);
        }

        if (!this.changeDetectorRef['destroyed']) {
            this.changeDetectorRef.detectChanges();
        }
    }
}
